import React, { useState } from "react";
import db from "../../../db/index.json";
import SearchBar from "../../reusebale/searchBar";
import LeasesTable from "../leases/leaseTable";
import FilterPopup from "../../popup/filterPopup";
import DetailLeaseMain from "./leaseDetail/main";
import DetailMain from '../maintenance/maintanance-detail/detailMain'
import MainTenantSection from "../tenants/tenantsDetail/main"

const LeasesSection = ({ toggleMaintainanceTable, toggleLeaseDetail, onViewMaintainDetails, toggleLeaseTable }) => {
  const { lease } = db;
  const [showFilter, setShowFilter] = useState(false);
  const [showTable, setShowTable] = useState("table");
  const [showDetail, setShowDetail] = useState("");
  const [recordId, setRecordId] = useState();
  const [recordMainId, setRecordMainId] = useState();
  const [recordTenantId, setRecordTenantId] = useState("");

  const toggleDetailMaintain = () => {
    setShowTable("MaintainanceDetails");
  };

  const isViewTenantDetail = (item) => {
    setRecordTenantId(item)
    setShowTable("TenantDetails");
  };

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = (status, id) => {
    setShowDetail(status);
    setRecordId(id);
    localStorage.setItem('leaseid', id);
    localStorage.setItem('leasestatus', status);
    setShowTable("detail"); // State toggle karein
  };

  const toggleDetailLease = () => {
    const id = localStorage.getItem('leaseid');
    const status = localStorage.getItem('leasestatus');
    setRecordId(id)
    setShowDetail(status)
    setShowTable("detail");
  }

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };

  const [search, setSearch] = useState("")

  return (
    <div>
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div>
                <div className="h-[10vh]">
                  <SearchBar
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                    title={lease.title}
                    desc={lease.desc}
                    onSubmit={openPopup}
                  />
                </div>
                <div className="h-[90vh]">
                  <LeasesTable
                    search={search}
                    isViewDetails={toggleDetail}
                    onViewDetailsTenant={isViewTenantDetail}
                  />
                </div>
              </div>
            );
          case "detail":
            return (
              <DetailLeaseMain
                onBack={toggleTable}
                showDetailStatus={showDetail}
                onLeaseTable={toggleLeaseTable}
                recordId={recordId}
                onViewDetailsMaintain={(item) => {
                  setRecordMainId(item);
                  toggleDetailMaintain(item);
                }}
                onMaintainancePage={toggleMaintainanceTable}
              />
            );
          case "MaintainanceDetails":
            return (
              <DetailMain
                recordId={recordMainId._id}
                onBack={toggleDetailLease}
              />
            );
          case "TenantDetails":
            return (
              <MainTenantSection
                seletedTenant={recordTenantId}
                toggleLeaseDetail={toggleLeaseDetail}
                onBack={toggleDetailLease}
                onViewMaintainDetails={onViewMaintainDetails}
              />
            );
          default:
            break;
        }
      })()}
      {showFilter && <FilterPopup onBack={closePopup} onFilter={closePopup} />}
    </div>
  );
};

export default LeasesSection;
